import DocumentTypes from '../config/documentTypes';

const i18nHelper = {
  
  BRAZIL_ID: 31,

  getDocumentTypeOptions: (countryId, t) => {
    if (countryId === i18nHelper.BRAZIL_ID) {
      return [
        { value: DocumentTypes.CPF, label: 'CPF' },
        { value: DocumentTypes.CNPJ, label: 'CNPJ' }
      ];
    }
    return [
      { value: DocumentTypes.PASSPORT, label: t('passport') },
    ];
  },

  /**
   * Resolves the initial document type for the responsible person, honoring the
   * type already registered in the booking when it is a selectable option for
   * the country; otherwise falls back to the country default.
   */
  resolveDocumentType: (countryId, documentType) => {
    const isBrazilian = countryId === i18nHelper.BRAZIL_ID;
    const allowed = isBrazilian
      ? [DocumentTypes.CPF, DocumentTypes.CNPJ]
      : [DocumentTypes.PASSPORT];
    const parsed = parseInt(documentType);

    if (allowed.includes(parsed)) return parsed;

    return isBrazilian ? DocumentTypes.CPF : DocumentTypes.PASSPORT;
  },
};

export default i18nHelper;
